"use client";

import { useFormContext, useWatch } from "react-hook-form";
import { TouristsOrderInfo } from "./TouristsOrderInfo";

export const TouristsOrderInfoList = ({
    name = "forTourists",
}: {
    name: string;
}) => {
    const { control } = useFormContext();
    const tourists: [] = useWatch({ control, name });

    return (
        <div className="flex w-full flex-col gap-4">
            {tourists?.map((_, index) => (
                <TouristsOrderInfo name={name} index={index} key={index} />
            ))}
        </div>
    );
};
